import { getService } from 'reducers/service';
import ServiceName from '../../shared/constants/serviceName';
import { addCreatedUpdatedBy } from 'utils/functions';

export const getPeopleSops = async (personId) => {
  const service = getService(ServiceName.RecordPersonSops);
  const response = await service.find({
    query: {
      IsDeleted: false,
      ptsParentID: personId,
      ParentType: 'Person',
      $sort: { Created: -1 },
    },
  });
  return response?.data || response || [];
};

export const getApprovedSops = async () => {
  const service = getService(ServiceName.PtsSops);
  const response = await service.find({
    query: {
      SOPID: { $ne: null },
      $limit: 1000,
      IsApproved: true,
      IsDeleted: false,
    },
  });
  return response?.data || response || [];
};

export const savePersonSop = async (payload) => {
  const service = getService(ServiceName.RecordPersonSops);
  return service.create(payload);
};

export const deletePersonSop = async (query) => {
  const service = getService(ServiceName.RmsAssignedSops);
  return service.remove(query);
};

export const getPlaceSops = async (ptsPlaceID) => {
  const service = getService(ServiceName.RecordPersonSops);
  const response = await service.find({
    query: {
      IsDeleted: false,
      ptsParentID: ptsPlaceID,
      ParentType: 'Place',
      $sort: { Created: -1 },
    },
  });
  return response?.data || response || [];
};

export const getAddressSops = async (ptsAddressID) => {
  const service = getService(ServiceName.RecordPersonSops);
  const response = await service.find({
    query: {
      IsDeleted: false,
      ptsParentID: ptsAddressID,
      ParentType: 'Address',
      $sort: { Created: -1 },
    },
  });
  return response?.data || response || [];
};

export const getZoneSops = async (zoneId) => {
  const response = await getService(ServiceName.RecordPersonSops).find({
    query: { IsDeleted: false, $sort: { Created: -1 }, ptsParentID: zoneId, ParentType: 'Zone' },
  });
  return response?.data || response || [];
};

export const saveZoneSop = async ({ ptsParentID, ptsSOPID }) => {
  const payload = addCreatedUpdatedBy({ ptsParentID, ptsSOPID, ParentType: 'Zone' });
  const response = await getService(ServiceName.RecordPersonSops).create(payload);
  return response?.data || response;
};

export const deleteZoneSop = async ({ ptsParentID, ptsSOPID }) => {
  return getService(ServiceName.RmsAssignedSops).remove({
    ptsParentID,
    ptsSOPID,
    ParentType: 'Zone',
  });
};
